import { map as i } from "nanostores";
function l() {
  if (window.__hydra_copilot__ != null && "copilotInstructions" in window.__hydra_copilot__)
    return window.__hydra_copilot__;
  const o = i({}), t = i({}), _ = i({}), n = { copilotInstructions: o, copilotTools: t, copilotContext: _ };
  return Object.assign(window, { __hydra_copilot__: n }), n;
}
const { copilotInstructions: c, copilotTools: e, copilotContext: s } = l();
function a(o) {
  if (!window.__hydra_copilot__)
    throw new Error("Copilot global state is not initialized.");
  Object.assign(window.__hydra_copilot__, o);
}
function r() {
  return Math.random().toString(36).substring(2, 15);
}
function p(o) {
  const t = r();
  return c.setKey(t, o), () => {
    c.setKey(t, void 0);
  };
}
function u(o) {
  return e.setKey(o.name, o), () => {
    e.setKey(o.name, void 0);
  };
}
function w(o) {
  const t = r();
  return s.setKey(t, o), () => {
    s.setKey(t, void 0);
  };
}
export {
  w as addContext,
  p as addInstruction,
  u as addTool,
  s as copilotContext,
  c as copilotInstructions,
  e as copilotTools,
  l as initializeGlobalState,
  a as setCopilotConfig,
  r as uniqueId
};
